<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
viewBox="0 0 414735 414735"
 xmlns:xlink="http://www.w3.org/1999/xlink">
 <g id="Vrstva_x0020_1">
  <rect class="fil0" width="414735" height="414735" rx="40443" ry="40443"/>
  <path class="fil1" d="M157449 315267l-57929 -57689c1364,-2379 155783,-156798 158063,-158068l57646 57585 -157780 158172zm94549 -225212l-161839 161835 -19295 19530c-3096,3101 -5721,7841 -4291,14663 1346,6415 5089,7312 7912,11528 -4834,7218 -17231,12765 -11235,18760 5995,5996 11542,-6401 18760,-11235l27745 27437c-1997,2904 -5623,5934 -8153,8460 -1926,1926 -7601,6090 -3239,10452 5996,5996 11543,-6401 18761,-11236 1487,997 13667,16132 26191,3621l19525 -19294 161840 -161839c8512,-11944 26687,-19408 23585,-34189 -1345,-6415 -5089,-7317 -7907,-11528 2318,-3470 11297,-11075 12033,-12439 2559,-4726 -2398,-9683 -7119,-7124 -618,330 -3361,3267 -4130,4041 -2526,2530 -5557,6151 -8309,7997l-27749 -27437c2488,-3612 11467,-11250 12194,-12596 2559,-4720 -2398,-9677 -7124,-7119 -1364,737 -8969,9716 -12439,12034 -1483,-992 -13667,-16127 -26191,-3616l-19526 19294z"/>
 </g>
</svg>
</template>

<script>
export default {
  name: 'UVLamp',
};
</script>

<style scoped>
.fil1 {fill:#FEFEFE}
.fil0 {fill:#00A0E3}
</style>
